<template>
    <div>
        <el-form :model="emailRecipients">
            <el-form-item label-width="140px"
                          :label="label ? label : `Recipient${this.recipientLimit == 1 ? '' : '/s'}`">
                <el-select
                    v-model="emailRecipients.recipients"
                    class="w-100"
                    filterable
                    clearable
                    remote
                    multiple
                    :remote-method="handleRecipientSearch"
                    :disabled="recipientsDisabled"
                    :multiple-limit="recipientLimit"
                    :placeholder="`Select or enter recipient${this.recipientLimit == 1 ? '' : '/s'}`"
                    :loading="loading"
                    :allow-create="recipientAllowCreate"
                    default-first-option
                >
                    <el-option v-for="recipient in recipients" :key="recipient.key" :label="recipient.label"
                               :value="recipient">
                        <span style="float: left">{{ recipient.full_name }}</span>
                        <span v-if="emailIsManual"
                              style="float: right; color: #8492a6; font-size: 13px">{{ recipient.email }}</span>
                        <span v-else style="float: right; color: #8492a6; font-size: 13px">{{
                                recipient.groupName
                            }}</span>
                    </el-option>
                </el-select>
                <slot></slot>
            </el-form-item>

            <el-row>
                <el-col v-if="!hideCC" :span="hideBCC ? 24 : 13">
                    <el-form-item label-width="140px" label="Cc">
                        <el-select
                            v-model="emailRecipients.cc"
                            class="w-100"
                            filterable
                            clearable
                            multiple
                            placeholder="Select or enter Cc"
                            :loading="loading"
                            :allow-create="ccAllowCreate"
                            default-first-option
                            collapse-tags
                        >
                            <el-option v-for="recipient in cc" :key="recipient.key" :label="recipient.label"
                                       :value="recipient">
                                <span style="float: left">{{ recipient.full_name }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{
                                        recipient.groupName
                                    }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col v-if="!hideBCC" :span="hideCC ? 24 : 11">
                    <el-form-item :label-width="hideCC ? '140px' : '60px'" label="Bcc">
                        <el-select
                            v-model="emailRecipients.bcc"
                            class="w-100"
                            filterable
                            clearable
                            multiple
                            placeholder="Select or enter Bcc"
                            :loading="loading"
                            :allow-create="bccAllowCreate"
                            default-first-option
                            collapse-tags
                        >
                            <el-option v-for="recipient in bcc" :key="recipient.key" :label="recipient.label"
                                       :value="recipient">
                                <span style="float: left">{{ recipient.full_name }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{
                                        recipient.groupName
                                    }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex"

export default {
    name: "EmailRecipients",
    props: {
        hideRecipients: {
            required: false,
            type: Boolean,
            default: false
        },
        recipientsDisabled: {
            required: false,
            type: Boolean,
            default: false
        },
        autoSelectRecipients: {
            required: false,
            default: true,
            type: Boolean,
        },
        autoSelectType: {
            required: false,
            default: "applicant",
            type: [String, Array],
        },
        selectRecipients: {
            required: false,
            type: Array,
            default: function () {
                return []
            },
        },
        addRecipients: {
            required: false,
            default: function () {
                return []
            },
            type: Array,
        },
        recipientLimit: {
            required: false,
            default: 0,
            type: Number,
        },
        recipientType: {
            required: false,
            default: "",
            type: [String, Array],
        },
        populateRecipients: {
            required: false,
            default: true,
            type: Boolean,
        },
        populateCcRecipients: {
            required: false,
            default: true,
            type: Boolean,
        },
        populateBccRecipients: {
            required: false,
            default: true,
            type: Boolean,
        },
        recipientAllowCreate: {
            required: false,
            default: true,
            type: Boolean,
        },
        ccAllowCreate: {
            required: false,
            default: true,
            type: Boolean,
        },
        bccAllowCreate: {
            required: false,
            default: true,
            type: Boolean,
        },
        hideCC: {
            required: false,
            default: false,
            type: Boolean,
        },
        hideBCC: {
            required: false,
            default: false,
            type: Boolean,
        },
        loadRecipients: {
            required: false,
            type: Array,
            default: function () {
                return []
            },
        },
        loadVideoCallRecipients: {
            required: false,
            type: Array,
            default: function () {
                return []
            },
        },
        label: {
            required: false,
            type: String,
        },
        placeholder: {
            required: false,
            type: String,
        },
        applicationId: {
            type: [Number, String],
            required: false
        },
        customEmailRecipient: {
            type: String,
            required: false
        },
    },
    data() {
        return {
            loading: false,
            recipients: [],
            cc: [],
            bcc: [],
            emailRecipients: {
                recipients: [],
                cc: [],
                bcc: [],
            },
        }
    },
    created() {
        if (!this.loadedRecipients) {
            this.emailRecipients.recipients = []
            this.emailRecipients.cc = []
            this.emailRecipients.bcc = []
            this.recipients = []
            this.cc = []
            this.bcc = []
            this.loading = true
        }
    },
    computed: {
        ...mapGetters({
            allRecipients: "builderEmail/getRecipients",
            emailBuilder: "builderEmail/getEmail",
            emailIsManual: "builderEmail/getEmailIsManual"
        }),
        computedApplicationId() {
            if (!this.applicationId) {
                return this.$store.getters.appId
            }
            return this.applicationId
        },
        loadedRecipients() {
            if (_.isEmpty(this.loadRecipients)) return false
            console.log('loadedRecipients before')
            return this.loadRecipients.map((recipient) => {
                let id = recipient.applicant_id ? recipient.applicant_id : _.get(recipient, 'user_id', _.get(recipient, 'id'))
                return {
                    id: `${_.get(recipient, 'group', 'applicant')}-${id}`,
                    user_id: id,
                    key: `${_.get(recipient, 'type')}-${id}`,
                    value: id,
                    email: recipient.email,
                    label: `${_.get(recipient, 'name', _.get(recipient, 'full_name'))} <${_.get(recipient, 'type')}>`,
                    full_name: _.get(recipient, 'name', _.get(recipient, 'full_name', '')),
                    phone: _.get(recipient, 'phone'),
                    phoneIsMobile: _.get(recipient, 'phoneIsMobile'),
                    group: _.get(recipient, 'type'),
                    groupName: _.startCase(_.get(recipient, 'type')),
                    template: {},
                }
            })
        },
    },
    mounted() {
        this.$store.dispatch("builderEmail/fetchEmailRecipients").then(res => {
            if (!_.isEmpty(this.addRecipients)) {
                this.addRecipients.forEach((recipient) => {
                    if (_.isNumber(recipient)) {
                        let recipientData = this.allRecipients.find((find) => {
                            let findId = find.id.includes('-') ? _.get(find.id.split('-'), '1') : find.id
                            return findId == recipient
                        })
                        if (recipientData) {
                            let isSet = this.recipients.find((recipient) => recipient.id == recipientData.id)
                            if (!isSet) this.recipients.push(recipientData)
                            this.emailRecipients.recipients.push(recipientData)
                        }
                    } else {
                        this.emailRecipients.recipients.push(recipient)
                    }
                    this.loading = false
                })
                this.handleRecipient()
            }
        })

        // On mount add recipients if they are passed in as a customEmailRecipient
        if (this.customEmailRecipient) {
            // add a string (this.customEmailRecipient) to the array this.emailRecipients.recipients
            this.emailRecipients.recipients.push(this.customEmailRecipient)
        }
    },
    methods: {
        ...mapActions({searchUsers: "builderEmail/searchUsers"}),
        createRecipients(createRecipients) {
            let recipients = createRecipients.map((recipient, key) => {
                // fix to make contact group to seller group
                if (recipient.group == "contact") {
                    recipient.group = "seller"
                }

                recipient.key = `${key}-${recipient.id}`
                recipient.value = recipient.id
                recipient.label = `${recipient.full_name} <${recipient.group}>`
                recipient.groupName = _.startCase(recipient.group)
                recipient.template = {}
                return recipient
            })

            this.cc = this.populateCcRecipients ? recipients : []
            this.bcc = this.populateBccRecipients ? recipients : []

            if (!_.isEmpty(this.recipientType)) {
                if (_.isArray(this.recipientType)) {
                    recipients = recipients.filter((recipient) => {
                        return this.recipientType.find((recipientType) => recipient.group == recipientType)
                    })
                    if (_.size(this.recipientType) > 1) {
                        recipients = this.mapOrder(recipients, this.recipientType, "group")
                    }
                } else {
                    recipients = recipients.filter((recipient) => recipient.group == this.recipientType)
                }
            }

            this.recipients = this.populateRecipients ? recipients : []

            if (this.autoSelectRecipients && this.computedApplicationId) {
                // auto select all auto select types
                if (this.recipientLimit !== 1) {
                    let recipients = []
                    if (this.autoSelectType) {
                        if (this.autoSelectType == "all") {
                            recipients = this.recipients
                        } else if (_.isArray(this.autoSelectType)) {
                            recipients = this.recipients.filter((recipient) => {
                                return this.autoSelectType.find((autoSelectType) => recipient.group == autoSelectType)
                            })
                        } else {
                            recipients = this.recipients.filter((recipient) => recipient.group == this.autoSelectType)
                        }
                    }

                    if (_.isArray(recipients)) {
                        Vue.set(this.emailRecipients, "recipients", recipients)
                    } else {
                        this.emailRecipients.recipients.push(recipients)
                    }
                } else {
                    //auto select first auto select type
                    let recipient = this.recipients.find((recipient) => recipient.group == this.autoSelectType)
                    this.emailRecipients.recipients.push(recipient)
                }
            } else {
                if (!_.isEmpty(this.selectRecipients)) {
                    console.log('this.selectRecipients ', this.selectRecipients)

                    let selectedRecipients = this.selectRecipients.map((recipientEmail) => {
                        return this.recipients.find((recipient) => recipient.email === recipientEmail)
                    })

                    if (_.isArray(selectedRecipients)) {
                        Vue.set(this.emailRecipients, "recipients", selectedRecipients)
                    } else {
                        this.emailRecipients.recipients.push(selectedRecipients)
                    }
                }
            }

            console.log('createRecipients ', this.recipients, this.emailRecipients.recipients)

            this.loading = false
        },
        handleRecipient() {
            let mobilePattern = /04[\d]{8}/g
            let recipients = this.emailRecipients.recipients.map((recipient) => {
                let isMobile = mobilePattern.test(recipient)

                if (_.isString(recipient)) {
                    return {
                        id: recipient,
                        key: recipient,
                        value: recipient,
                        label: recipient + " <other>",
                        email: !isMobile ? recipient : null,
                        phone: isMobile ? recipient : null,
                        phoneIsMobile: isMobile ? true : false,
                        full_name: recipient,
                        group: "other",
                        groupName: "Other",
                        template: {},
                    }
                }
                return recipient
            })

            this.$store.dispatch("builderEmail/setRecipients", recipients)
        },
        handleCc() {
            let mobilePattern = /04[\d]{8}/g
            let ccs = this.emailRecipients.cc.map((cc) => {
                let isMobile = mobilePattern.test(cc)
                if (_.isString(cc)) {
                    return {
                        id: cc,
                        key: cc,
                        value: cc,
                        label: cc + " <other>",
                        email: !isMobile ? cc : null,
                        phone: isMobile ? cc : null,
                        phoneIsMobile: isMobile ? true : false,
                        full_name: cc,
                        group: "other",
                        groupName: "Other",
                        template: {},
                    }
                }
                return cc
            })
            this.$store.dispatch("builderEmail/setCc", ccs)
        },
        handleBcc() {
            let mobilePattern = /04[\d]{8}/g
            let bccs = this.emailRecipients.bcc.map((bcc) => {
                let isMobile = mobilePattern.test(bcc)
                if (_.isString(bcc)) {
                    return {
                        id: bcc,
                        key: bcc,
                        value: bcc,
                        label: bcc + " <other>",
                        email: !isMobile ? bcc : null,
                        phone: isMobile ? bcc : null,
                        phoneIsMobile: isMobile ? true : false,
                        full_name: bcc,
                        group: "other",
                        groupName: "Other",
                        template: {},
                    }
                }
                return bcc
            })
            this.$store.dispatch("builderEmail/setBcc", bccs)
        },
        handleRecipientSearch(query) {
            if (query !== '' && !this.computedApplicationId) {
                this.searchUsers(query);
            }
        },
        mapOrder(array, order, key) {
            array.sort(function (a, b) {
                var A = a[key],
                    B = b[key]
                if (order.indexOf(A) > order.indexOf(B)) {
                    return 1
                } else {
                    return -1
                }
            })

            return array
        },
    },
    watch: {
        loadVideoCallRecipients: {
            handler(val) {
                if (val) {
                    this.createRecipients(val)
                }
            },
            deep: true,
            immediate: true,
        },
        loadedRecipients: {
            handler(loadedRecipients) {
                if (loadedRecipients) {
                    this.createRecipients(loadedRecipients)
                }
            },
            deep: true,
            immediate: true,
        },
        allRecipients: {
            handler(allRecipients) {
                if (!this.loadedRecipients) {
                    this.createRecipients(allRecipients)
                }
            },
            immediate: true,
            deep: true,
        },
        emailRecipients: {
            handler(recipients) {
                this.$emit("input", recipients)
            },
            deep: true,
        },
        'emailRecipients.recipients': {
            handler() {
                this.handleRecipient()
            },
            immediate: true,
            deep: true,
        },
        'emailRecipients.cc': {
            handler() {
                this.handleCc()
            }
        },
        'emailRecipients.bcc': {
            handler() {
                this.handleBcc()
            }
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
